<div class="modal-header">
  <h4 class="modal-title">
    @if (amenity) {
      Bloques de horarios para reservar {{ amenity.name }} 
    }
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  <div class="row">

    <div class="col-12 d-none d-lg-block">

      <div class="row">

        <div class="col text-center">
          Inicio
        </div>
        <div class="col text-center">
          Fin
        </div>
        <div class="col text-center">
          Lunes
        </div>
        <div class="col text-center">
          Martes
        </div>
        <div class="col text-center">
          Miércoles
        </div>
        <div class="col text-center">
          Jueves
        </div>
        <div class="col text-center">
          Viernes
        </div>
        <div class="col text-center">
          Sábado
        </div>
        <div class="col text-center">
          Domingo
        </div>
        <div class="col text-center d-block d-lg-none d-xl-block">
          Acciones
        </div>

      </div>
      <div class="row">
        <div class="col-12">
          <hr>
        </div>
      </div>

    </div>

    <app-timetable-item
      [amenity]="amenity"
      (getData)="getData()"
      (closeModal)="activeModal.close()">
    </app-timetable-item>

    @for(timetable of timetables; track $index) {
      <app-timetable-item
        [amenity]="amenity"
        [timetable]="timetable"
        (getData)="getData()"
        (closeModal)="activeModal.close()">
      </app-timetable-item>
    }

  </div>
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-success w-100">
      OK
    </button>
  </div>
  <!-- <div class="col-12">
    <button
      type="submit"
      form="formAmenity"
      class="btn btn-primary w-100">
      {{ amenity ? 'Guardar' : 'Registrar' }}
    </button>
  </div> -->
</div>
